import { useState } from 'react';
import { ACTION_TYPES, usePoliticalPartySearchDispatch, usePoliticalPartySearchState } from './political-party-search-context';
import PoliticalPartyAppService from '../../../../application/platform/sge/political-party/political-party-app-service';
import { useFeedback } from '../../../../hooks/use-feedback';
import { IPoliticalPartyAddEditRequest } from '../../../../model/sge/political-party/request/political-party-add-edit-request';
import { IPoliticalPartyPagedResponse } from '../../../../model/sge/political-party/response/political-party-paged-response';

export const usePoliticalPartySearchController = () => {
    const dispatch = usePoliticalPartySearchDispatch();
    const state = usePoliticalPartySearchState();
    const { showSuccess, showError, withLoading } = useFeedback();
    const [isSaving, setIsSaving] = useState(false);

    // Filtros
    function handleOnChange(e: any) {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { term: e.target.value || undefined } });
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0 } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0, term: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handlePaginationChange(page: number, pageSize: number) {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page, pageSize } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    // Cadastro/edição: a listagem não traz todos os campos, então a edição busca o registro completo
    async function openDrawer(row?: IPoliticalPartyPagedResponse) {
        if (!row) {
            dispatch({ type: ACTION_TYPES.openDrawer });
            return;
        }
        try {
            const party = await withLoading(() => PoliticalPartyAppService.getById(row.id));
            dispatch({ type: ACTION_TYPES.openDrawer, payload: party });
        } catch (error: any) {
            showError('Não foi possível carregar o partido', error);
        }
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    async function handleSave(request: IPoliticalPartyAddEditRequest) {
        const editing = state.drawer.record;
        setIsSaving(true);
        try {
            if (editing) {
                await PoliticalPartyAppService.edit(editing.id, request);
                showSuccess('Partido atualizado com sucesso!');
            } else {
                await PoliticalPartyAppService.add(request);
                showSuccess('Partido adicionado com sucesso!');
            }
            closeDrawer();
            dispatch({ type: ACTION_TYPES.triggerSearch });
        } catch (error: any) {
            showError('Não foi possível salvar o partido', error);
        } finally {
            setIsSaving(false);
        }
    }

    return { isSaving, handleOnChange, handleSearch, handleClearFilters, handlePaginationChange, openDrawer, closeDrawer, handleSave };
};
